import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_text_field = _resolveComponent("v-text-field");
    const _component_InputRow = _resolveComponent("InputRow");
    const _component_CardSection = _resolveComponent("CardSection");
    return (_openBlock(), _createElementBlock("div", null, [
        _createVNode(_component_CardSection, {
            title: _ctx.$t(`${_ctx.lc}social_car_license_info`)
        }, {
            default: _withCtx(() => [
                _createVNode(_component_InputRow, {
                    label: _ctx.$t(`${_ctx.lc}social_number`)
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                            "model-value": _ctx.socialNumberRef,
                            density: "compact",
                            variant: "outlined",
                            "validate-on": "blur",
                            "hide-details": "auto",
                            inputmode: "numeric",
                            placeholder: _ctx.$t('common.input_field_placeholder', { field: '주민등록번호' }),
                            rules: _ctx.formRules.socialNumber.value,
                            maxlength: _ctx.HYPEN_SOCIAL_NUMBER_LIMIT_LENGTH,
                            "onUpdate:modelValue": _ctx.handleInputSocialNumber,
                            onFocus: _ctx.handleFocusSocialNumber,
                            onBlur: _ctx.handleBlurSocialNumber
                        }, null, 8 /* PROPS */, ["model-value", "placeholder", "rules", "maxlength", "onUpdate:modelValue", "onFocus", "onBlur"])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label"]),
                _createVNode(_component_InputRow, {
                    label: _ctx.$t(`${_ctx.lc}car_number`)
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                            modelValue: _ctx.carNumberComputed,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.carNumberComputed) = $event)),
                            density: "compact",
                            variant: "outlined",
                            "hide-details": "auto",
                            "validate-on": "blur",
                            placeholder: _ctx.$t('common.input_field_placeholder', { field: '차량번호' }),
                            rules: _ctx.formRules.carNumber.value,
                            maxlength: _ctx.CAR_NUMBER_MAX_LENGTH
                        }, null, 8 /* PROPS */, ["modelValue", "placeholder", "rules", "maxlength"])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label"]),
                _createVNode(_component_InputRow, {
                    label: _ctx.$t(`${_ctx.lc}license_number`)
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                            modelValue: _ctx.licenseNumberComputed,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.licenseNumberComputed) = $event)),
                            density: "compact",
                            variant: "outlined",
                            "hide-details": "auto",
                            "validate-on": "blur",
                            maxlength: _ctx.LICENSE_NUMBER_MAX_LENGTH,
                            placeholder: _ctx.$t('common.input_field_placeholder', { field: '면허번호' }),
                            rules: _ctx.formRules.licenseNumber.value,
                            onBlur: _ctx.onBlurLicenseNumberField
                        }, null, 8 /* PROPS */, ["modelValue", "maxlength", "placeholder", "rules", "onBlur"])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label"])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["title"])
    ]));
}
